export const closeSubMenu = () => {
  const sideMenu = document.querySelector('.wbcs-side-menu');
  if (sideMenu.classList.contains('sidemenu-open')) {
    sideMenu.classList.remove('sidemenu-open');
  }

  const navClose = document.querySelectorAll('.nav-close');

  navClose.forEach((el) => {
    if (el.classList.contains('nav-open')) {
      el.classList.remove('nav-open');
    }
  });
};

// export const closeWbcsSideMenu = () => {
//   const sideMenu = document.querySelector('.wbcs-side-menu');
//   if (sideMenu.classList.contains('sidemenu-open')) {
//     sideMenu.classList.remove('sidemenu-open');
//   }
// };
